import { BrandingService } from '@services/index';
import { AccountService } from '@services/index';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '@reducers/index';
import * as UserContextActions from '@actions/user-context/user-context.actions';
import * as BrandingActions from '@actions/branding/branding.actions';
import { datadogRum } from '@datadog/browser-rum';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { environment } from '@environments/environment';
import { RealtimeGatewayService } from '@services/index';
import { MomentTimezoneDateAdapter } from './modules/dashboard/directives/moment-timezone-adapter';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    private onDestroy$: Subject<void> = new Subject<void>();
    currentTimeZone: string;

    constructor(
        private store$: Store<AppState>,
        private brandingService: BrandingService,
        private accountService: AccountService,
        private realtimeService: RealtimeGatewayService
    ) {
        this.realtimeService.initConnection();
    }

    private dataDogRum(): void {
        datadogRum.init({
            applicationId: '09d60619-e794-43f7-a71e-ffff935f93f3',
            clientToken: 'pubb721e43fbca6190906a82e643d8f7ace',
            site: 'us3.datadoghq.com',
            service: 'virsae-dashboards',
            env: environment.environmentName.toLowerCase(),
            sessionSampleRate: 100,
            sessionReplaySampleRate: 100,
            startSessionReplayRecordingManually: false,
            trackUserInteractions: true,
            defaultPrivacyLevel: 'mask-user-input'
        });

        datadogRum.setUser({
            id: this.accountService.getUserDetails().UserId,
            name: this.accountService.getUserDetails().FullNameFL,
            email: this.accountService.getUserDetails().UserName
        });
    }

    public ngOnInit(): void {
        if (environment.production) {
            this.dataDogRum();
        }

        this.store$.dispatch(UserContextActions.GetUserContexts());
        this.store$
            .pipe(
                select(state => state.dashboard.userContext),
                takeUntil(this.onDestroy$)
            )
            .subscribe((data: any) => {
                if (data) {
                    MomentTimezoneDateAdapter.appTimeZone = data.TimeZoneId || 'UTC';
                    MomentTimezoneDateAdapter.prototype.setTimezone();
                    this.store$.dispatch(BrandingActions.GetBrandingColors({ entityId: data.EntityId }));
                    this.store$.dispatch(BrandingActions.GetBusinessPartnerLogo({ entityId: data.EntityId }));
                }
            });
        this.store$
            .pipe(
                select(state => state.branding.colors),
                takeUntil(this.onDestroy$)
            )
            .subscribe(data => {
                this.brandingService.applyBrandingColors(data.primaryColour, data.secondaryColour);
            });
    }

    public ngOnDestroy(): void {
        this.onDestroy$?.next();
        this.onDestroy$?.complete();
    }
}
